export const CMS_PREVIEW_PLACEHOLDER_ASSET_ID = '__cms_preview_placeholder__';

export type CmsImageDimensions = {
  width: number;
  height: number;
};

export type CmsImageSource = {
  assetId: string;
};

export type CmsResolvedImageSource = CmsImageSource & {
  url?: string;
  width?: number;
  height?: number;
};

export type CmsImageSourceValue = '' | CmsImageSource;
export type CmsHydratedImageSourceValue =
  | CmsImageSourceValue
  | CmsResolvedImageSource;

export type CmsImageRenderAsset = {
  src: string;
  dimensions?: CmsImageDimensions;
};

export function readCmsImageDimensions(
  value: unknown
): CmsImageDimensions | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined;
  }

  const { width, height } = value as {
    width?: unknown;
    height?: unknown;
  };
  if (
    typeof width !== 'number' ||
    !Number.isInteger(width) ||
    width <= 0 ||
    typeof height !== 'number' ||
    !Number.isInteger(height) ||
    height <= 0
  ) {
    return undefined;
  }

  return { width, height };
}

export function resolveCmsImageRenderAsset(
  value:
    | string
    | CmsHydratedImageSourceValue
    | CmsImageSourceValue
    | null
    | undefined
): CmsImageRenderAsset {
  if (!value || typeof value === 'string') {
    return { src: value ?? '' };
  }

  if (value.assetId === CMS_PREVIEW_PLACEHOLDER_ASSET_ID) {
    return { src: '' };
  }

  const src = 'url' in value && typeof value.url === 'string' ? value.url : '';
  const dimensions = readCmsImageDimensions(value);

  return dimensions ? { src, dimensions } : { src };
}

export function resolveCmsImageSource(
  value: CmsHydratedImageSourceValue | CmsImageSourceValue | null | undefined
): string {
  return resolveCmsImageRenderAsset(value).src;
}
